<div class="py-[30px] px-[50px]">
  <div>
    <img class="w-[53px] h-[53px]" src="https://oss.image.xiaogetech.com/FHO1683887470636.png" alt="" />
    <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
    <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
  </div>

  <div class="text-l font-bold text-center mt-[30px] md:text-left">
    {{ "与抖音来客直连" | translate }}
  </div>

  <div class="text-m mt-[30px]">
    {{ "百居易是抖音来客的官方直连合作伙伴，在直连之前，您需要了解以下事项：" | translate }}
  </div>

  <div class="text-m mt-[30px]">
    <ol>
      <li>
        1. 请确保您已经有抖音来客 （<a href="https://life.douyin.com/" target="_blank">https://life.douyin.com/</a>）
        的账号，并且可以正常经营。
      </li>
      <li>2. 抖音来客直连目前还在内测中，您可以先报名，以获得优先直连的机会。</li>
    </ol>
  </div>

  <div class="footer text-right mt-[30px]">
    <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">
      {{ "word.cancel" | translate }}
    </button>
    <button nz-button nzSize="large" nzType="primary" (click)="onFinish()">
      {{ "已有抖音来客账号，现在报名" | translate }}
    </button>
  </div>
</div>
